import type { MaterialValue, PartDefinition } from '@rogue/rackbuilder'
import type { CTTowerOptions } from '../../RackTypes'
import { findBundleProduct } from '../../utils/product-lookup'
import { getCommonAccessorySelections, getHeightSelection } from '../../utils/selection-utils'
import { CTM1Builder } from './ctm1Builder'
import type { IRogue, BuyRequest } from '@/js/services/RogueTypes'
import { getSimpleForBuyRequest } from '@/js/helpers/buy-request'

export function createCTM1(rogue: IRogue, buyRequest: BuyRequest): {config: Partial<CTTowerOptions>, part: PartDefinition} | undefined {
  const rack = getSimpleForBuyRequest(buyRequest, rogue)
  const weightStack = rack.attributes.edition?.toString().includes('250') ? '250' : '300'
  const standAlone = rack.attributes?.rig_or_wm?.toString().toLowerCase().includes('alone')

  const materials: {[key: string] : {[key: string] : MaterialValue}} = {}
  const seatSelection = findBundleProduct(rogue, buyRequest, 'seat', true)?.name
  const bandPegs = !!findBundleProduct(rogue, buyRequest, 'band peg', true)

  const { trolleySelection, lowRowSelection, latBarSelection } =  getCommonAccessorySelections(rogue, buyRequest, materials)

  const config: CTTowerOptions =   {
    line     : 'RM',
    numbered : true,
    height   : getHeightSelection(rack),
    color    : 'black',
    hardware : 'isonite',
    weightStack,
    trolleySelection,
    latBarSelection,
    lowRowSelection,
    seatSelection,
    bandPegs,
    standAlone,
    materials,
  }

  const part = new CTM1Builder(config).build()

  return { part, config }
}
